<template>
  <div class="page-header">
    <h2>Available parts</h2>
    <!-- <div class="part-packages-radio">
      <label for="parts">
        <input
          type="radio"
          name="parts-packages"
          id="parts"
          value="parts"
          v-model="partsOrPackages"
          v-on:change="partsOrPackagesSelected"
          checked
        />
        Parts
      </label>
      <label for="packages">
        <input
          type="radio"
          name="parts-packages"
          id="packages"
          value="packages"
          v-model="partsOrPackages"
          v-on:change="partsOrPackagesSelected"
        />
        Packages
      </label>
    </div> -->
  </div>
  <!-- <hr /> -->
  <div>
    <!-- <div class="w3-container"> -->
    <div class="part" style="background-color: #ffffff !important">
      <div class="part-title">Filter {{ partsOrPackages }}.</div>
      <div style="display: flex; flex-direction: row">
        <!-- <p>Categories: </p>  -->
        <div v-for="category in categories" v-bind:key="category">
          <div :class="colors[category.category_id]">
            <label>
              <input
                :id="'category' + category.category_id"
                type="checkbox"
                @click="filterByCategory()"
                style="display: none"
              />
              <span class="w3-btn w3-border w3-border-white">{{
                category.name
              }}</span>
            </label>
          </div>
        </div>
      </div>
      <template v-if="selectedCategories.length != 0 ">
        <template v-for="selectedCategory in selectedCategories" v-bind:key="selectedCategory">
          <template v-if="selectedCategory.mandatory_details != '{}'">
            <br>
            <label><b>Filter within category "{{selectedCategory.name}}"</b>
            <input :id="'checkbox_filter_' + selectedCategory.category_id" type="checkbox" v-model='filterWithinCategory[selectedCategory.category_id]' @change="filterByCategory()">
            </label>
            <br>
          </template>
          <template v-if="filterWithinCategory[selectedCategory.category_id]">
            <template v-for="(detail, name, index) in JSON.parse(selectedCategory.mandatory_details)" v-bind:key="(detail, name, index)">
              <label>
                {{name}}
                <select :id="'filter_' + selectedCategory.category_id + '_' + index " 
                  @click="filterByCategory()">
                  <option value="greater"> &gt; </option>
                  <option value="equal"> = </option>
                  <option value="lesser"> &lt; </option>
                </select>
                <input type="number" :id="'filter_value_' + selectedCategory.category_id + '_' + index " default=0 @change="filterByCategory()" value="0">
              </label> <br>
            </template>
          </template>
        </template>
      </template>
    </div>
    <!-- </div> -->
  </div>
  <hr />

  <!-- Parts -->
  <!-- <div id="v-for-parts"> -->
  <div v-if="parts !== undefined">
    <!-- {{ parts }} -->
    <template v-for="(part, key) in parts" v-bind:key="(part, key)">
      <template
        v-if="
          part.available
          && 
          (filteredParts[key] || selectedCategories.length == 0 )
        "
      >
        <!-- {{ part }} -->
        <div class="part" style="background-color: #ffffff !important">
          <div class="part-title">{{ part.name }}</div>
          <div class="part-content">
            <div class="part-description">
              <p v-if="readMore[part.part_id]" style="white-space: pre-line" v-html="part.description">
              </p>
              <p v-if="!readMore[part.part_id]" style="white-space: pre-line" v-html="part.description.substring(0, 200) + '...' ">
              </p>

              <table
                v-if="
                  readMore[part.part_id] &&
                  Object.keys(part.details).length != 0
                "
                class="w3-table-all"
              >
                <thead>
                  <tr>
                    <th>Characteristic</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tr v-for="(detail) in part.details" v-bind:key="detail">
                  <template v-if="detail.visible">
                    <th>{{ detail.name }}</th>
                    <th v-html="detail.value"></th>
                  </template>
                </tr>
              </table>

              <br />

              <button
                type="button"
                @click="showMore(part.part_id)"
                v-if="!readMore[part.part_id]"
              >
                Show more
              </button>
              <button
                type="button"
                @click="showMore(part.part_id)"
                v-if="readMore[part.part_id]"
              >
                Show less
              </button>

              <div style="display: flex; flex-direction: row">
                <!-- <p>Categories: </p>  -->
                <div v-for="category in part.categories" v-bind:key="category">
                  <p style="white-space: wrap" class="tooltip">
                    <span
                      class="w3-tag w3-border w3-border-white"
                      :class="colors[category.id]"
                    >
                      {{ category.name }}</span
                    >
                    <!-- <span class="tooltiptext">{{ category.description.substring(0, 200) + ".." }}</span> -->
                  </p>
                </div>
              </div>
            </div>

            <div class="part-price">
              <span :id="'price_' + part.part_id"
                ><b>{{ part.unit_prices[0].chf }}</b></span
              >
              CHF / unit <br />
              <br />
              <!-- <label
                :for="'number_of_' + part.part_id"
                style="display: flex; flex-direction: row"
              >
                Quantity:
                <input
                  :name="'number_of_' + part.part_id"
                  :id="'number_of_' + part.part_id"
                  type="number"
                  min="0"
                  style="width: 50%; padding-right: 0"
                  v-model="quantity[part.part_id]"
                  v-on:change="partQuantityChanged(part)"
                />
              </label> -->
              <label>Quantity:</label>
              <input
                class="w3-input w3-border w3-round"
                type="number"
                :min="part.moq"
                :placeholder="'Minimun quantity: ' + part.moq"
                v-model="quantity[part.part_id]"
                v-on:keyup.enter="setUserDetails(part)"
                v-on:change="partQuantityChanged(part)"
                v-on:keyup="partQuantityChanged(part)"
              />

              <div style="padding-top: 5px">
                <button
                  type="button"
                  :id="'add_button_' + part.part_id"
                  @click="setUserDetails(part)"
                  disabled="true"
                >
                  Add to cart (<span :id="'calculated_price_' + part.part_id">{{
                    part.unit_prices[0].chf
                  }}</span>
                  CHF)
                </button>
              </div>

              <div style="padding-top: 5px">
                <table class="w3-table-all">
                  <tr v-for="price in part.unit_prices" v-bind:key="price">
                    <th>> {{ price.qty }}</th>
                    <th>{{ price.chf }} CHF / unit</th>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <br />
      </template>
    </template>
    <!-- </div> -->
    <!-- <div v-else>
      Fetching parts
    </div> -->
  </div>

  <div id="user_inputsModal" class="w3-modal">
    <div class="w3-modal-content w3-animate-right">
      <header class="w3-container w3-border-bottom w3-padding-10 w3-light-grey">
        <span @click="cancelAddToCart" class="w3-button w3-display-topright"
          >&times;</span
        >
        <h5>
          ADD TO CART - Configure <b>{{ selectedPart.name }}</b>
        </h5>
      </header>

      <div class="w3-container">
        <br />
        <div
          :id="'v-for-user_inputs_' + selectedPart.part_id"
          style="display: block"
          class="part-user_inputs w3-container"
        >
          <div v-for="input in selectedPart.user_inputs" v-bind:key="input">
            <div v-if="input.type == 'text'">
              <label :for="input.name" class="tooltip">
                <span class="tooltiptext">{{ input.desc }}</span>
                {{ input.name }}
              </label>
              <input
                class="w3-input w3-border w3-round"
                type="text"
                :id="input.name"
                :name="input.name"
              />
            <p style="color:gray">{{ input.desc }}</p>
            </div>

            <div v-else-if="input.type == 'comment'">
              <label :for="input.name" class="tooltip">
                <span class="tooltiptext">{{ input.desc }}</span>
                <div v-html="input.name"></div>
              </label>
            </div>

            <div v-else-if="input.type == 'link'">
                <a :href="input.desc" target="_blank" rel="noreferrer noopener">{{ input.name }}</a>
            </div>
            <div v-else-if="input.type == 'list'">
              <label :for="input.name" class="tooltip">
                <span class="tooltiptext">{{ input.desc }}</span>
                {{ input.name }}
              </label>
              <select
                class="w3-select w3-border w3-round"
                :name="input.name"
                :id="input.name"
              >
                <option disabled selected>Select an option</option>
                <option
                  v-for="option in input.options"
                  v-bind:key="option"
                  v-bind:value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
              <p style="color: gray;">{{ input.desc }}</p>
            </div>

            <div v-else-if="input.type == 'boolean'">
              <label class="tooltip">
                <span class="tooltiptext">{{ input.desc }}</span>
                {{ input.name }}
              </label>
              <input
                class="w3-check w3-border w3-round"
                type="checkbox"
                :id="input.name"
                :name="input.name"
                :value="input.value"
              />
              <p style="color:gray">{{ input.desc }}</p>
            </div>
            <br>
          </div>
        </div>
      <div class="w3-panel w3-yellow" id="inputmodal-warning" style="display: none;"></div> 
      </div>
      <br />
      <!-- <button class="close" @click="cancelAddToCart" style="background-color: transparent; outline: none; border: none;">&times;</button> -->
      <footer
        class="w3-container w3-border-top w3-light-grey w3-white w3-border"
        style="text-align: right"
      >
        <p>
          <button @click="addToCart" class="w3-button">Proceed</button>
        </p>
      </footer>
    </div>
  </div>
</template>

<style scoped src="@/assets/styles.css">
</style>
<style scoped>
:checked + span {
  /* For the selection of categories in the filter */
  background-color: rgba(
    100,
    100,
    100,
    0.3
  ) !important; /* Darken the color of the label */
  border-block-color: black;
  font-weight: bold;
}
</style>
<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: -50%;
  left: 110%;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: 0;
  border-width: 5px;
  border-style: solid;
  border-color: transparent black transparent transparent;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>>

<script>
export default {
  name: "Order",
  methods: {
    partsOrPackagesSelected: function () {
      console.log(this.partsOrPackages);
    },

    showMore: function (id) {
      this.readMore[id] = !this.readMore[id];
    },

    partQuantityChanged: function (part) {
      var price_display = document.getElementById("price_" + part.part_id);
      var calculated_price_display = document.getElementById(
        "calculated_price_" + part.part_id
      );
      var quantity = this.quantity[part.part_id];

      var add_button = document.getElementById("add_button_" + part.part_id);

      add_button.disabled = false;

      if (quantity == 0) add_button.disabled = true;

      var i;
      if (part.unit_prices.length == 1)
        calculated_price_display.innerHTML = part.unit_prices[0].chf * quantity;
      else
        for (i = 0; i < part.unit_prices.length - 1; i++) {
          console.log(part.unit_prices.length - 1);
          if (
            quantity >= part.unit_prices[i].qty &&
            quantity <= part.unit_prices[i + 1].qty
          ) {
            price_display.innerHTML = part.unit_prices[i].chf;
            calculated_price_display.innerHTML =
              part.unit_prices[i].chf * quantity;
          } else if (quantity >= part.unit_prices[i + 1].qty) {
            price_display.innerHTML = part.unit_prices[i + 1].chf;
            calculated_price_display.innerHTML =
              part.unit_prices[i + 1].chf * quantity;
          }
        }
    },
    // Cart functionality
    addToCart: function () {
      var part = this.selectedPart;
      var quantity = this.quantity[part.part_id];
      var user_inputs = {};
      var price = part.unit_prices[0].chf * quantity; // Total price
      var i;
      console.log(part.unit_prices)
      console.log(part.unit_prices.length)
      for (i = 1; i < part.unit_prices.length; i++) {
        if (
          quantity >= part.unit_prices[i].qty &&
          quantity <= part.unit_prices[i + 1].qty
        )
          price = part.unit_prices[i].chf * quantity;
        else if (quantity >= part.unit_prices[i + 1].qty)
          price = part.unit_prices[i + 1].chf * quantity;
      }
      var addToCardAllowed = true;
      if (part.user_inputs != []) {
        part.user_inputs.forEach((input) => {
          if (input.type != "comment" && input.type != "link") {
            var input_element = document.getElementById(input.name);
            console.log(input.name, input.type, input_element.checked)
            if (input.type == "boolean") {
              user_inputs[input.name] = input_element.checked;
              console.log( 'input.name == \"Export Restrictions\"', input.name == "Export Restrictions" )
              console.log( '!input_element.checked', !input_element.checked )
              console.log( input.name == "Export Restrictions" && !input_element.checked )
              if (input.name == "Export Restrictions" && !input_element.checked ) {
                document.getElementById("inputmodal-warning").style.display = 'block';
                document.getElementById("inputmodal-warning").innerText = "Please read the Export Control documentation and check the box.";
                addToCardAllowed = false;
              }
              else if (input.name == "Export Restrictions" && input_element.checked ) {
                document.getElementById("inputmodal-warning").style.display = 'none';
                addToCardAllowed = true;
              }
            } else if (input.type == "list") {
              console.log(document.getElementById(input.name).value);
              user_inputs[input.name] = document.getElementById(input.name).value;
            } else {
              user_inputs[input.name] = document.getElementById(input.name).value;
            }
          }
        });
        if (!addToCardAllowed) { return; }
        console.log(user_inputs);
      }
      var storedPart = {
        part_id: part.part_id,
        quantity: parseInt(quantity),
        price: parseFloat(price),
        user_inputs: user_inputs,
        partOrPackage: "part",
        name: part.name,
        key: part.part_id + "_" + part.name.replaceAll(" ", "_"),
        reqshipment: part.reqshipment,
      };
      this.$store.dispatch("addPartToBasket", storedPart);

      //Clear selection and disable 'add' button
      this.quantity[part.part_id] = 0;
      document.getElementById("add_button_" + part.part_id).disabled = true;

      //Close modal
      document.getElementById("user_inputsModal").style.display = "none";
    },
    cancelAddToCart: function () {
      document.getElementById("user_inputsModal").style.display = "none";
    },
    setUserDetails: function (part) {
      var quantity = this.quantity[part.part_id];
      this.selectedPart = part;
      if (part.user_inputs.length == 0) {
        this.addToCart();
        return;
      }
      if (quantity > 0) {
        document.getElementById("user_inputsModal").style.display = "block";
      } else {
        document.getElementById("user_inputsModal").style.display = "none";
      }
    },
    filterByCategory: function () {
      var i;
      this.selectedCategories = []
      for (i = 0; i < this.categories.length; i++) {
        var category = this.categories[i];
        if (document.getElementById("category" + (i + 1)).checked) {
          this.selectedCategories.push(category);
        }
      }
      var aux_filteredParts = {};

      // Filter parts by category
      for (const [part_id, part] of Object.entries(this.parts)) {
          aux_filteredParts[part_id] = this.selectedCategories.some(obj => part.categories.some(category => category.id == obj.category_id));
      }        
      // Filter parts by characteristics in the categories
      for (const [part_id, part] of Object.entries(this.parts)) {
        if ( aux_filteredParts[part_id] ) {
          for( i= 0 ; i < this.selectedCategories.length ; i++) {
            if ( part.categories.some( category =>  this.selectedCategories[i].category_id == category.id ) && ( this.filterWithinCategory[this.selectedCategories[i].category_id] ) ) {
              var j = 0;
              for ( const [detail_name] of Object.entries(JSON.parse(this.selectedCategories[i].mandatory_details)) ) {
                var comparsion = document.getElementById('filter_' + this.selectedCategories[i].category_id + '_' + j).value
                switch( comparsion ) {
                  case "greater":
                    aux_filteredParts[part_id] = aux_filteredParts[part_id] && (part.details.filter(p => p.name == detail_name)[0].value > parseInt(document.getElementById('filter_value_' + this.selectedCategories[i].category_id + '_' + j).value) )
                    break;
                  case "equal":
                    aux_filteredParts[part_id] = aux_filteredParts[part_id] && (part.details.filter(p => p.name == detail_name)[0].value == parseInt(document.getElementById('filter_value_' + this.selectedCategories[i].category_id + '_' + j).value) )
                    break;
                  case "lesser":
                    aux_filteredParts[part_id] = aux_filteredParts[part_id] && (part.details.filter(p => p.name == detail_name)[0].value < parseInt(document.getElementById('filter_value_' + this.selectedCategories[i].category_id + '_' + j).value) )
                    break;
                  default:
                    break;
                }
                j++;
              }
            }
          }
        }
      }
      this.filteredParts = aux_filteredParts;
      // console.log("filteredParts", this.filteredParts);
    },
  },
  data() {
    return {
      readMore: {},
      partsOrPackages: "parts",
      quantity: {},
      selectedPart: {},
      selectedCategories: [],
      filteredParts: {},
      filterWithinCategory: {}
      // parts: {}
    };
  },
  // beforeCreate() {
  // this.$store.dispatch("setParts");
  // },
  computed: {
    parts() {
      return JSON.parse(JSON.stringify(this.$store.getters.getParts));
    },
    colors() {
      return [
        "w3-red",
        "w3-purple",
        "w3-light-blue",
        "w3-amber",
        "w3-pale-red",
        "w3-pale-green",
        "w3-pale-yellow",
      ];
    },
    categories() {
      return JSON.parse(JSON.stringify(this.$store.getters.getCategories));
    },
  },
  async mounted() {
    var parts = JSON.parse(JSON.stringify(this.$store.getters.getParts));
    Array.from(parts).forEach((part) => (this.quantity[part.part_id] = 0));
    Array.from(parts).forEach(
      (part) =>
        (document.getElementById("add_button_" + part.part_id).disabled = true)
    );

    // var categories = JSON.parse(JSON.stringify(this.$store.getters.getCategories));
    // Array.from(categories).forEach((category) => this.filterWithinCategory[category.category_id] = false);

  },
};
</script>